<template>
  <div class="project">
    <div class="p-image"></div>

    <div class="right-container">
      <div>
        <!-- <transition name="fadeOne">
          <div v-show="show" class="container-2"> -->
        <p class="One">Party forum</p>
        <p class="description">
          This is one my first experiments with Wordpress and the one that made
          me see this CMS in a different light.
        </p>
        <!-- </div>
        </transition> -->
        <transition name="fadeTwo">
          <div v-show="show" class="container-2">
            <a href="https://bagel-79264.web.app/" class="Two"
              >click here to visit</a
            >
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.container-2 {
  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
}
.project {
  width: auto;
  height: auto;
  background: #000;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 15px;
}
button {
  color: #435466;
  font-size: 15px;
  font-weight: 600;
  background-color: #fff;
  margin: auto;
  width: 100px;
  height: 50px;
  border: #3b3561;
}
.right-container {
  display: grid;
  grid-template-rows: 1fr 0.1fr;
}
.p-image {
  background: url("../assets/party-forum.png");
  height: 35vh;
  width: 62vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.description {
  font-size: 1.5em;
  font-family: "Roboto", sans-serif;
}
p {
  text-align: end;
  font-size: 50px;
  font-family: "Stalinist One", cursive;
  overflow: hidden;
  color: #4dba87;
  margin: 1px;
}

.Two {
  font-size: 18px;
}

.fadeOne-enter-active,
.fadeOne-leave-active {
  transition: all 0.5s ease-out;
}
.fadeOne-enter,
.fadeOne-leave-to {
  clip-path: polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%);
  transform: translate(0%, 100%);
}

.fadeTwo-enter-active,
.fadeTwo-leave-active {
  transition: all 0.5s ease-out;
}
.fadeTwo-enter,
.fadeTwo-leave-to {
  clip-path: polygon(0% 100%, 100% 100%, 0% 100%, 0% 100%);
  transform: translate(0%, -100%);
}
@media screen and (max-width: 600px) {
  .project {
    width: 100%;
    grid-template-columns: 1fr;
    place-items: center;
  }
  .p-image {
    width: 44.4vh;
    height: 25vh;
  }
  p {
    text-align: start;
  }
}
</style>
